"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormPrepend = void 0;
var react_1 = __importDefault(require("react"));
var AcFormField_module_scss_1 = __importDefault(require("./AcFormField.module.scss"));
// Layout for the AC Form
var AcFormPrepend = function (_a) {
    var prepend = _a.prepend, size = _a.size, onIconClick = _a.onIconClick;
    return (react_1.default.createElement("div", { className: AcFormField_module_scss_1.default.prependDiv }, prepend && react_1.default.createElement("span", { onClick: onIconClick }, prepend)));
};
exports.AcFormPrepend = AcFormPrepend;
exports.AcFormPrepend.displayName = 'AcFormPrepend';
//# sourceMappingURL=AcFormPrepend.js.map